define("Ames.RentFromAnywhere.RentFromAnywhere", [
  "Ames.RentFromAnywhere.RentFromAnywhere.View",
  "RentFromAnywhere.Checkout.View",
  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",
  "jQuery",
  "Utils",
  "LiveOrder.Model",
  "Ames.RentFromAnywhere.RentalConfirmation.Module",
  "Ames.RentFromAnywhere.RentalOrder.History.View",
  "Ames.RentFromAnywhere.RentalGrid",
  "Ames.RentFromAnywhere.PaymentRestriction",
  "Ames.RentFromAnywhere.AccessGate",
  "Ames.RentFromAnywhere.Terms.Module",
  "Ames.RentFromAnywhere.RentalLine",
], function (
  RentFromAnywhereView,
  RentFromAnywhereCheckoutView,
  RentFromAnywhereSS2Model,
  jQuery,
  Utils,
  LiveOrderModel,
  RentalConfirmationModule,
  RentalOrdersView,
  RentalGrid,
  PaymentRestriction,
  AccessGate,
  RentalTermsModule,
  RentalLine
) {
  "use strict";

  return {
    mountToApp: function (container) {
      var layout = container.getComponent("Layout");
      var pdp = container.getComponent("PDP");
      var checkout = container.getComponent("Checkout");
      var myaccount = container.getComponent("MyAccount");
      this.liveOrderInstance = LiveOrderModel.getInstance();
      var self = this;

      // Register the "Rental Tools Grid" custom content type (SMT)
      RentalGrid.mountToApp(container);

      // Rental orders are credit card only (hides other payment options,
      // blocks submit otherwise). Runs in shopping (cart) and checkout.
      PaymentRestriction.mountToApp(container);

      if (checkout) {
        // Rental orders: required "I agree to the RFA Terms & Conditions"
        // checkbox on the Review step (inactive for carts without rental lines).
        RentalTermsModule.register(container);

        // Redirect rental / mixed orders to the custom confirmation page.
        // We wrap LiveOrder.submit() instead of relying on the
        // before:/after:LiveOrder.submit events so the redirect runs as soon
        // as the order save resolves, before the wizard navigates to its own
        // confirmation step. In local mode go through the local shopping SSP.
        var isLocal = /checkout-local\.ssp/.test(window.location.pathname);
        var confirmationUrl = isLocal
          ? window.location.origin + "/scs/shopping-local.ssp#rental-confirmation-step"
          : window.location.origin + "/rental-confirmation-step";

        // Shared strict rule (Ames.RentFromAnywhere.RentalLine): a configurable
        // set also carries custcol_custom_price + description, so only
        // custcol_custom_rate / "N Days Rental" identify a rental line.
        function cartHasRentalLines(liveOrder) {
          return RentalLine.cartHasRentalLines(liveOrder);
        }

        // Breadcrumbs: after checkout run
        //   JSON.parse(sessionStorage.getItem("rfa_last_submit"))
        // in the console to see whether the redirect was attempted.
        function breadcrumb(step, extra) {
          var entry = _.extend(
            { step: step, at: new Date().toISOString(), origin: window.location.origin },
            extra || {}
          );
          try { console.log("[RFA]", entry); } catch (e) {}
          try { sessionStorage.setItem("rfa_last_submit", JSON.stringify(entry)); } catch (e) {}
        }

        var originalSubmit = LiveOrderModel.prototype.submit;
        LiveOrderModel.prototype.submit = function () {
          var liveOrder = this;
          var rental = cartHasRentalLines(liveOrder);
          var lines = liveOrder.get("lines");
          breadcrumb("before-submit", { isRental: rental, lines: lines ? lines.length : 0 });

          var promise = originalSubmit.apply(this, arguments);

          if (rental && promise && _.isFunction(promise.done)) {
            promise.done(function (response) {
              // Remember the order just placed so the confirmation page asks
              // for THAT order instead of "the customer's latest" (which can
              // come back stale right after checkout).
              var placedId = null;
              try {
                var conf = (response && response.confirmation) || liveOrder.get("confirmation") || {};
                placedId = conf.internalid || conf.id ||
                  (response && (response.internalid || response.orderid)) || null;
                if (!placedId && response && response.confirmationnumber) placedId = null; // tranid only, not usable
                breadcrumb("submit-response-shape", { keys: response ? Object.keys(response).slice(0, 25) : null, confirmation: conf });
                if (placedId) sessionStorage.setItem("rfa_last_order_id", String(placedId));
              } catch (e) {}
              breadcrumb("after-submit-redirect", { to: confirmationUrl, orderId: placedId });
              window.location.href = confirmationUrl;
            });
            promise.fail(function (jqXhr) {
              breadcrumb("submit-failed", { status: jqXhr && jqXhr.status });
            });
          }
          return promise;
        };
      }
      
      var PageType = container.getComponent("PageType");

      var MyAccountMenuComponent = container.getComponent("MyAccountMenu");
      var rentalOrdersMenuGroup = {
        id: "rentalorders",
        name: "Rental Order History",
        index: 6,
        url: "rental-orders",
      };
      MyAccountMenuComponent.addGroup(rentalOrdersMenuGroup);
      // if (!checkout && !pdp) {

      //   PageType.registerPageType({
      //     name: "rentalorders",
      //     routes: ["rental-orders"],
      //     view: RentalOrdersView,
      //     options: {
      //       application: container,
      //     },
      //     defaultTemplate: {
      //       name: "tavano_ttrentalorders_rentalorders.tpl",
      //       displayName: "Rental Orders Page",
      //     },
      //   });
      // }

      if (!layout || !pdp) {
        return;
      }

      PageType.registerPageType({
        name: "rental-confirmation-step",
        routes: ["rental-confirmation-step"],
        view: RentalConfirmationModule,
        defaultTemplate: {
          name: "rental_confirmation.tpl",
          displayName: "Rental Confirmation Step",
        },
      });

      // Persisted flag getter
      function isRentItem() {
        var itemInfo = pdp.getItemInfo();
        return !!(
          itemInfo &&
          itemInfo.item &&
          itemInfo.item.custitem_nst_rrm_rt_daily
        );
      }

      function isRentalCart() {
        var liveOrder = LiveOrderModel.getInstance();
        var lines = liveOrder.get("lines");

        if (!lines || !lines.models) {
          return false;
        }

        return _.some(lines.models, RentalLine.isRentalLine);
      }

      // RENTAL PDP NOTICE: on a rental item's PDP hide the standard quantity /
      // Add to Cart and point the shopper to the Rent From Anywhere page.
      // Purely additive: the rental period table / rent button (if rendered
      // by RentFromAnywhereView) are left untouched.
      var RENTAL_PAGE_URL = "/rental";
      // Set to true to bring back the rental period table + "Rent Now" on the
      // PDP (RentFromAnywhereView). While false, rental PDPs only show the
      // "Rental item" notice linking to the rental page.
      var SHOW_PDP_RENTAL_MODULE = false;

      function applyRentalPdpNotice() {
        try {
          var isRent = isRentItem();
          // body-level class so sticky/cloned add-to-cart buttons rendered
          // outside the PDP container are covered too
          jQuery("body").toggleClass("rfa-rental-pdp-page", !!isRent)
            .toggleClass("rfa-rental-pdp-module-off", !!isRent && !SHOW_PDP_RENTAL_MODULE);
          if (!isRent) return;
          var $pdp = jQuery(".product-details-full, .product-details-quick-view, [data-view=\"Product.Details\"]").first();
          if (!$pdp.length) return;
          $pdp.addClass("rfa-rental-pdp");
          var unlocked = AccessGate.isUnlocked();
          var $existing = $pdp.find(".rfa-rental-notice");
          if ($existing.length) {
            // already rendered; refresh only if the gate state changed
            if ($existing.data("rfaUnlocked") === unlocked) return;
            $existing.remove();
          }

          // Client-side gate: until unlocked the notice offers the login
          // modal instead of the link to the rental page.
          var $notice = jQuery(
            '<div class="rfa-rental-notice">' +
              '<span class="rfa-rental-notice-badge">Rental item</span>' +
              (unlocked
                ? '<span class="rfa-rental-notice-text">This tool is available through our Rent From Anywhere program.</span>' +
                  '<a class="rfa-rental-notice-link" href="' + RENTAL_PAGE_URL + '" data-touchpoint="home" data-hashtag="#rental">View rental options</a>'
                : '<span class="rfa-rental-notice-text">This tool is part of our Rent From Anywhere program, currently available by invitation.</span>' +
                  '<a class="rfa-rental-notice-link rfa-rental-notice-link-gate" href="#" data-action="rfa-gate-open">Enter access credentials</a>') +
            '</div>'
          ).data("rfaUnlocked", unlocked);
          $notice.on("click", '[data-action="rfa-gate-open"]', function (ev) {
            ev.preventDefault();
            AccessGate.openModal(function () { applyRentalPdpNotice(); });
          });

          // Anchor: the standard add-to-cart area, else the quantity area,
          // else the end of the right-hand details column.
          var $anchor = $pdp.find('[data-view="Cart.AddToCart.Button"], .product-details-add-to-cart, [data-action="add-to-cart"]').first();
          if (!$anchor.length) $anchor = $pdp.find(".product-details-quantity-value").closest('[data-view="Quantity"], .product-details-quantity').first();
          if ($anchor.length) {
            $anchor.after($notice);
          } else {
            $pdp.find(".product-details-full-content-right, .product-details-full-content").first().append($notice);
          }
        } catch (e) {
          console.warn("RentFromAnywhere: rental PDP notice failed", e);
        }
      }
      layout.on("afterAppendView", applyRentalPdpNotice);
      if (pdp && _.isFunction(pdp.on)) {
        pdp.on("afterShowContent", applyRentalPdpNotice);
      }

      // Another extension may already define this context property;
      // SCA throws DUPLICATED_CONTEXT_PROPERTY in that case. Never let it
      // abort mountToApp (that blanks the whole page).
      try {
        // PRICE OVERRIDE (always available)
        layout.addToViewContextDefinition(
          "ProductViews.Price.View",
          "priceFormatted",
          "string",
          function (context) {
            if (!isRentItem()) {
              var newPrice = context.model.custcol_custom_price
                ? parseFloat(context.model.custcol_custom_price)
                : null;
              var formattedPrice = newPrice
                ? Utils.formatCurrency(newPrice)
                : context.priceFormatted;
              return formattedPrice;
            }

            var newPrice = context.model.custcol_custom_price
              ? parseFloat(context.model.custcol_custom_price)
              : null;

            return newPrice
              ? Utils.formatCurrency(newPrice)
              : context.priceFormatted;
          }
        );
      } catch (e) {
        console.warn("RentFromAnywhere: could not add priceFormatted context property", e);
      }

      // Another extension may already define this context property;
      // SCA throws DUPLICATED_CONTEXT_PROPERTY in that case. Never let it
      // abort mountToApp (that blanks the whole page).
      try {
        // ADD TO CART BUTTON CONTROL (persistent)
        layout.addToViewContextDefinition(
          "Cart.AddToCart.Button.View",
          "isRent",
          "boolean",
          function () {
            return isRentItem();
          }
        );
      } catch (e) {
        console.warn("RentFromAnywhere: could not add isRent context property", e);
      }

      // Your custom Quantity child view (rental period table + Rent Now).
      // Kept intact; only registered when SHOW_PDP_RENTAL_MODULE is true.
      if (SHOW_PDP_RENTAL_MODULE) {
        layout.addChildView("Quantity", function () {
          return new RentFromAnywhereView({ container: container });
        });
      }
    },
  };
});
